import React from 'react';
import './Skeleton.css';

interface SkeletonProps {
  width?: string;
  height?: string;
  className?: string;
}

// `minWidth` acompaña a `width` para poder pintar piezas más estrechas que el
// mínimo por defecto (iconos, badges) sin que el CSS base las ensanche.
export const Skeleton = ({ width, height, className = '' }: SkeletonProps) => (
  <div className={`skeleton ${className}`} style={{ width, height, minWidth: width }} />
);
